var map = {
	"./ar.json": 2504,
	"./de.json": 9124,
	"./en.json": 3952,
	"./es.json": 1495,
	"./fr.json": 7363,
	"./hi.json": 2220,
	"./it.json": 7374,
	"./nl.json": 8553,
	"./ru.json": 6730,
	"./uk.json": 895,
	"./zh.json": 1025
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 132;